import React from 'react';

import * as helpers from './helpers';

const MaterialsIcon = ({
  color,
  width = 25,
  height = 25,
  ...props
}: {
  color: string,
  width: number,
  height: number,
}) => (
  <svg
    {...helpers.getSvgDimensionsProps({ width, height })}
    {...helpers.getViewBoxProperty({ width, height })}
    {...props}>
    <path
      d="M0.5625 7.57812L11.6719 13.625C11.7969 13.6875 11.9219 13.7188 12.0469 13.7188C12.1719 13.7188 12.2969 13.6875 12.4219 13.625L23.6719 7.57812C23.9219 7.42188 24.0469 7.20312 24.0469 6.92188C24.0469 6.60938 23.9062 6.39062 23.625 6.26562L12.5156 0.59375C12.2969 0.46875 12.0625 0.46875 11.8125 0.59375L0.5625 6.26562C0.3125 6.39062 0.171875 6.60938 0.140625 6.92188C0.140625 7.20312 0.28125 7.42188 0.5625 7.57812ZM12.1875 2.09375L21.7031 6.92188L12.0469 12.125L2.53125 6.92188L12.1875 2.09375ZM23.5312 11.75L21.2812 10.625L19.6875 11.5156L21.5625 12.4531L11.9062 17.6562L2.39062 12.4531L4.40625 11.4688L2.8125 10.5781L0.46875 11.75C0.1875 11.875 0.046875 12.0938 0.046875 12.4062C0.046875 12.7188 0.171875 12.9375 0.421875 13.0625L11.5781 19.1562C11.6719 19.2188 11.7812 19.25 11.9062 19.25C12.0312 19.25 12.1562 19.2188 12.2812 19.1562L23.5312 13.0625C23.8125 12.9375 23.9375 12.7344 23.9062 12.4531C23.9062 12.1406 23.7812 11.9062 23.5312 11.75ZM23.5312 17L21.4219 15.9688L19.7812 16.8594L21.5625 17.7031L11.9062 22.9062L2.39062 17.7031L4.26562 16.8594L2.67188 15.9688L0.46875 17C0.1875 17.125 0.046875 17.3438 0.046875 17.6562C0.046875 17.9688 0.171875 18.1875 0.421875 18.3125L11.5781 24.4062C11.6719 24.4688 11.7812 24.5 11.9062 24.5C12.0312 24.5 12.1562 24.4688 12.2812 24.4062L23.5312 18.3594C23.8125 18.2031 23.9375 17.9844 23.9062 17.7031C23.9062 17.3906 23.7812 17.1562 23.5312 17Z"
      fill={color}
    />
  </svg>
);

export default MaterialsIcon;
